import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { AiOutlineSearch as SearchIcon } from 'react-icons/ai';
import { TiDelete as ClearIcon } from 'react-icons/ti';

import {
  TeamSearchWrapper,
  InputContainer,
  SearchInput,
  Options,
  Option,
  Category,
  Highlight,
  Name,
  Flag
} from './styled';

const getMatch = (text, search) => text?.toLowerCase()?.includes(search?.toLowerCase());

const TeamSearch = ({ team, onMemberSelect }) => {
  const [searchValue, setSearchValue] = useState('');
  const [disabled, setDisabled] = useState(false);
  const searchRef = useRef();

  const matches = team.filter(
    ({ firstName, lastName, role, country }) =>
      getMatch(firstName, searchValue) ||
      getMatch(lastName, searchValue) ||
      getMatch(role, searchValue) ||
      getMatch(country, searchValue)
  );

  const hideKeyboard = () => {
    searchRef.current.blur();
    setDisabled(true);

    setTimeout(function () {
      setDisabled(false);
    }, 100);
  };

  const onClear = () => {
    setSearchValue('');
    searchRef.current.focus();
    onMemberSelect(null);
  };

  const onSelect = (member) => {
    onMemberSelect(member);
    setSearchValue('');
    hideKeyboard();
  };

  const renderName = (name) => {
    if (name?.toLowerCase().startsWith(searchValue?.toLowerCase())) {
      return (
        <Name>
          <Highlight>{searchValue?.[0]?.toUpperCase() + searchValue?.slice(1)}</Highlight>
          {name.slice(searchValue?.length)}{' '}
        </Name>
      );
    }

    return <Name>{name}</Name>;
  };

  return (
    <TeamSearchWrapper>
      <InputContainer>
        <SearchInput
          placeholder="Search by name, role or location"
          ref={searchRef}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          disabled={disabled}
        />
        {searchValue ? <ClearIcon onClick={onClear} /> : <SearchIcon />}
      </InputContainer>

      <Options searchValue={searchValue}>
        {matches.map((member) => {
          const splitCountry = member?.country?.split('(');
          const countryCode = splitCountry?.[1]?.substring(0, splitCountry[1].length - 1);

          return (
            <Option key={member.id} onClick={() => onSelect(member)}>
              {countryCode && <Flag code={countryCode} height={16} />}
              {renderName(member.firstName)}
              {renderName(member.lastName)}
              {member?.categories?.[0] && <Category>/ {member.categories[0]}</Category>}
            </Option>
          );
        })}
      </Options>
    </TeamSearchWrapper>
  );
};

TeamSearch.propTypes = {
  team: PropTypes.array.isRequired,
  onMemberSelect: PropTypes.func.isRequired
};

export default TeamSearch;
